/* =========================================================
   Movimiento estilo iPhone (liquid glass):
   - Inclinación 3D suave hacia el cursor, con resorte
   - Brillo especular que sigue al cursor
   - Profundidad: la foto se mueve un poco al revés (paralaje)
   - Botones "magnéticos" que siguen al cursor
   - Presión elástica al hacer clic
   Solo en computadoras con mouse; respeta "reducir movimiento".
   ========================================================= */
(function () {
  var fine = window.matchMedia('(hover: hover) and (pointer: fine)').matches;
  var reduce = false; // se ve igual aunque el PC tenga las animaciones apagadas
  if (!fine || reduce) return;
  document.documentElement.classList.add('has-motion');

  // Resorte simple: se acerca al objetivo con inercia (como las animaciones de iOS)
  function Spring(stiffness, damping) {
    this.k = stiffness; this.d = damping; this.x = 0; this.v = 0; this.t = 0;
  }
  Spring.prototype.step = function (dt) {
    var f = -this.k * (this.x - this.t) - this.d * this.v;
    this.v += f * dt; this.x += this.v * dt;
    return Math.abs(this.x - this.t) > 0.001 || Math.abs(this.v) > 0.001;
  };

  var active = new Set();
  var last = performance.now();
  function loop(now) {
    var dt = Math.min(0.032, (now - last) / 1000); last = now;
    active.forEach(function (st) {
      var moving = false;
      st.springs.forEach(function (s) { if (s.step(dt)) moving = true; });
      st.apply();
      if (!moving && !st.hover) active.delete(st);
    });
    if (active.size) requestAnimationFrame(loop); else running = false;
  }
  var running = false;
  function kick(st) { active.add(st); if (!running) { running = true; last = performance.now(); requestAnimationFrame(loop); } }

  // ---------- Tarjetas con inclinación ----------
  var TILT = '.card, .hero-card, .spotlight, .trust-item, .step, .buy-box, .gallery, .cta-box, .faq details, .float-badge, .footer-box, .cart-summary';
  document.querySelectorAll(TILT).forEach(function (el) {
    var max = parseFloat(el.dataset.tiltMax) || (el.matches('.spotlight, .cta-box, .footer-box, .buy-box, .gallery, .cart-summary') ? 3 : el.matches('.faq details, .trust-item') ? 4 : 8);
    var lift = el.matches('.card, .hero-card') ? 1.03 : 1.012;
    var media = el.querySelector('.stage img');
    var rx = new Spring(170, 18), ry = new Spring(170, 18), sc = new Spring(220, 20), press = new Spring(380, 24);
    // "gelatina": resortes con poca fricción para que el vidrio tiemble como líquido
    var jx = new Spring(320, 6), jy = new Spring(320, 6);
    var jelly = el.matches('.spotlight, .cta-box, .footer-box, .buy-box, .gallery, .cart-summary') ? 0.4 : 1;
    var lastX = 0, lastY = 0, lastT = 0, idle;
    sc.x = sc.t = 1; press.x = press.t = 1;
    var st = { springs: [rx, ry, sc, press, jx, jy], hover: false, apply: function () {
      var s = sc.x * press.x;
      el.style.transform = 'perspective(1000px) rotateX(' + rx.x.toFixed(3) + 'deg) rotateY(' + ry.x.toFixed(3) + 'deg) scale(' + (s * (1 + jx.x)).toFixed(4) + ',' + (s * (1 + jy.x)).toFixed(4) + ')';
      if (media) media.style.transform = 'translate3d(' + (-ry.x * 1.6).toFixed(2) + 'px,' + (rx.x * 1.6).toFixed(2) + 'px,0) scale(' + (1 + (sc.x - 1) * 1.6).toFixed(4) + ')';
    } };
    el.classList.add('is-tilt');

    el.addEventListener('pointerenter', function () { st.hover = true; sc.t = lift; kick(st); });
    el.addEventListener('pointermove', function (e) {
      var r = el.getBoundingClientRect();
      var px = (e.clientX - r.left) / r.width, py = (e.clientY - r.top) / r.height;
      ry.t = (px - 0.5) * 2 * max;
      rx.t = -(py - 0.5) * 2 * max;
      el.style.setProperty('--mx', (px * 100).toFixed(1) + '%');
      el.style.setProperty('--my', (py * 100).toFixed(1) + '%');
      el.style.setProperty('--glare', '1');
      var now = performance.now(), dt = Math.max(8, now - lastT);
      if (lastT) {
        var vx = (e.clientX - lastX) / dt, vy = (e.clientY - lastY) / dt; // px por ms
        var ax = Math.min(0.06, Math.abs(vx) * 0.03) * jelly, ay = Math.min(0.06, Math.abs(vy) * 0.03) * jelly;
        jx.t = ax - ay * 0.5; jy.t = ay - ax * 0.5;
      }
      lastX = e.clientX; lastY = e.clientY; lastT = now;
      clearTimeout(idle);
      idle = setTimeout(function () { jx.t = 0; jy.t = 0; kick(st); }, 60);
      kick(st);
    });
    el.addEventListener('pointerleave', function () {
      st.hover = false; rx.t = 0; ry.t = 0; sc.t = 1; press.t = 1; jx.t = 0; jy.t = 0; lastT = 0;
      el.style.setProperty('--glare', '0');
      kick(st);
    });
    el.addEventListener('pointerdown', function () { press.t = 0.975; kick(st); });
    window.addEventListener('pointerup', function () { press.t = 1; kick(st); });
  });

  // ---------- Botones magnéticos ----------
  document.querySelectorAll('.btn, .icon-btn, .wa-float, .nav a').forEach(function (el) {
    var strength = el.matches('.nav a') ? 0.18 : 0.28;
    var tx = new Spring(260, 20), ty = new Spring(260, 20), sc = new Spring(300, 22);
    var gx = new Spring(340, 7), gy = new Spring(340, 7); // se estira como una gota hacia el cursor
    sc.x = sc.t = 1; gx.x = gx.t = 1; gy.x = gy.t = 1;
    var st = { springs: [tx, ty, sc, gx, gy], hover: false, apply: function () {
      el.style.transform = 'translate3d(' + tx.x.toFixed(2) + 'px,' + ty.x.toFixed(2) + 'px,0) scale(' + (sc.x * gx.x).toFixed(4) + ',' + (sc.x * gy.x).toFixed(4) + ')';
    } };
    el.addEventListener('pointerenter', function () { st.hover = true; sc.t = 1.05; kick(st); });
    el.addEventListener('pointermove', function (e) {
      var r = el.getBoundingClientRect();
      var dx = (e.clientX - (r.left + r.width / 2)), dy = (e.clientY - (r.top + r.height / 2));
      tx.t = dx * strength; ty.t = dy * strength;
      var rxn = Math.abs(dx) / (r.width / 2), ryn = Math.abs(dy) / (r.height / 2);
      gx.t = 1 + rxn * 0.09 - ryn * 0.04; gy.t = 1 + ryn * 0.09 - rxn * 0.04;
      kick(st);
    });
    el.addEventListener('pointerleave', function () { st.hover = false; tx.t = 0; ty.t = 0; sc.t = 1; gx.t = 1; gy.t = 1; kick(st); });
    el.addEventListener('pointerdown', function () { sc.t = 0.94; kick(st); });
    el.addEventListener('pointerup', function () { sc.t = st.hover ? 1.05 : 1; kick(st); });
  });

  // ---------- El fondo de luces se mueve un poco con el cursor ----------
  var orbs = document.querySelectorAll('.ambient span');
  if (orbs.length) {
    var ox = new Spring(40, 12), oy = new Spring(40, 12);
    var ost = { springs: [ox, oy], hover: true, apply: function () {
      orbs.forEach(function (o, i) {
        var f = (i + 1) * 14;
        o.style.translate = (ox.x * f).toFixed(1) + 'px ' + (oy.x * f).toFixed(1) + 'px';
      });
    } };
    window.addEventListener('pointermove', function (e) {
      ox.t = e.clientX / window.innerWidth - 0.5;
      oy.t = e.clientY / window.innerHeight - 0.5;
      kick(ost);
    }, { passive: true });
  }
})();
